/**
 * Custom promotions
 */
class CustomPromotions extends HTMLElement {
  constructor() {
    super();
    this.popupModals = this.querySelectorAll('.custom-promotions__modal');
    this.popupModalsObject = {};
    this.init();
  }
  init() {
    var self = this;
    this.popupModals.forEach(function (popupModal) {
      const popupModalBlockId = popupModal.dataset.blockId;

      if (popupModalBlockId) {
        self.popupModalsObject[popupModalBlockId] = new theme.Modals(
          'custom-promotions-' + popupModalBlockId,
          'custom-promotions-popup-modal-' + popupModalBlockId
        );
      }
    });
  }
}

customElements.define('custom-promotions', CustomPromotions);

/**
 * Custom video slider
 */
class CustomVideoSlider extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.dataset.sectionId;
    this.swiper = null;
    this.customVideoSliderItem = this.querySelectorAll('.custom-video-slider__video-item');
    this.customVideoSliderItemCount = this.customVideoSliderItem.length;
    const desktopInitialTotalVideoDisplay = parseInt(this.dataset.desktopInitialTotalVideoDisplay);
    const tabletInitialTotalVideoDisplay = parseInt(this.dataset.tabletInitialTotalVideoDisplay);
    const mobileInitialTotalVideoDisplay = parseInt(this.dataset.mobileInitialTotalVideoDisplay);
    const sliderVideoGap = parseInt(this.dataset.sliderVideoGap);
    this.config = {
      loopVideoSlider: this.dataset.loopVideoSlider === 'true',
      desktopInitialTotalVideoDisplay: desktopInitialTotalVideoDisplay >= this.customVideoSliderItemCount ? desktopInitialTotalVideoDisplay : desktopInitialTotalVideoDisplay + 0.1,
      tabletInitialTotalVideoDisplay: tabletInitialTotalVideoDisplay >= this.customVideoSliderItemCount ? tabletInitialTotalVideoDisplay : tabletInitialTotalVideoDisplay + 0.1,
      mobileInitialTotalVideoDisplay: mobileInitialTotalVideoDisplay >= this.customVideoSliderItemCount ? mobileInitialTotalVideoDisplay : mobileInitialTotalVideoDisplay + 0.5,
      sliderVideoGap: sliderVideoGap,
      lazyloadVideoSlider: this.dataset.lazyloadVideoSlider === 'true'
    };
    this.init();
  }
  init() {
    if (this.config.lazyloadVideoSlider) {
      this.initLazyloadSlider();
    } else {
      this.initSlider();
    }
  }
  initLazyloadSlider() {
    var self = this;

    const observerOptions = {
      root: null,
      threshold: 0.1
    };

    const sliderObserver = new IntersectionObserver(function (entries, observer) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          self.initSlider();
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);

    sliderObserver.observe(this);
  }
  initSlider() {
    this.swiper = new Swiper('.custom-video-slider__swiper[data-section-id="' + this.sectionId + '"]', {
      loop: this.config.loopVideoSlider,
      // slidesPerView: 'auto',
      slidesPerView: this.config.mobileInitialTotalVideoDisplay,
      slidesPerGroup: 1,
      spaceBetween: this.config.sliderVideoGap,
      breakpoints: {
        769: {
          slidesPerView: this.config.tabletInitialTotalVideoDisplay
        },
        1200: {
          slidesPerView: this.config.desktopInitialTotalVideoDisplay,
        }
      },
      navigation: {
        nextEl: '.swiper-button-next[data-section-id="' + this.sectionId + '"]',
        prevEl: '.swiper-button-prev[data-section-id="' + this.sectionId + '"]',
      },
      on: {
        init: function (swiper) {
          swiper.slides.forEach(function (slide, index) {
            const video = slide.querySelector('video');
            if (video && !video.getAttribute('src')) {
              video.src = video.dataset.src;
              video.load();
            }
          });
        }
      }
    });
  }
}

customElements.define('custom-video-slider', CustomVideoSlider);
